import { ModuleContext } from "./module-context";

// higher order decorator for components that module props
export const withModule = (WrappedComponent) => (props) =>
    (
        <ModuleContext.Consumer>
            {(value) => <WrappedComponent {...props} {...value} />}
        </ModuleContext.Consumer>
    );
